// extracted by mini-css-extract-plugin
export default {"table":"lGpt58vUkoECz7ekqIAu"};